import { render, staticRenderFns } from "./resume-citizenships-view.vue?vue&type=template&id=d9ff81ae&"
import script from "./resume-citizenships-view.vue?vue&type=script&lang=js&"
export * from "./resume-citizenships-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports